import { render, staticRenderFns } from "./V2vTransfer.vue?vue&type=template&id=15c5810a"
import script from "./V2vTransfer.vue?vue&type=script&lang=js"
export * from "./V2vTransfer.vue?vue&type=script&lang=js"
import style0 from "./V2vTransfer.vue?vue&type=style&index=0&id=15c5810a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports